import React from 'react';
import { ChatInterface } from '../chat/ChatInterface';

/**
 * Client-specific chat component wrapper
 * This allows for client-specific customizations while using the shared ChatInterface
 */
export const ClientChat = ({ customerId }) => {
  return (
    <ChatInterface 
      customerId={customerId} 
      viewType="client"
    />
  );
};

export default ClientChat;